import React from 'react';
import ReactDOM from 'react-dom';
import { Router, Route, Switch } from 'react-router-dom';
import { ApolloProvider } from 'react-apollo';
import indexRoutes from 'routes/index';
import adminClient, { history } from 'client';
import RouterContext from 'helpers/routerContext';
import AuthProvider from 'components/User/AuthProvider';
import GraphqlErrorBoundary from 'components/common/GraphqlErrorBoundary';
import 'assets/scss/material-dashboard-pro-react.css?v=1.3.0';
import Moment from 'react-moment';
import moment from 'moment';
import 'moment-timezone/moment-timezone';
import 'i18n';
// Fix when exists some Moments timer instances

// load moment Havana timezone
moment.tz.load({
  version: '2019b',
  zones: [
    // eslint-disable-next-line max-len
    'America/Havana|HMT CST CDT|5t.A 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Meuu.o 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5',
  ],
  links: ['America/Havana|Cuba'],
});

Moment.startPooledTimer();
moment.tz.setDefault('America/Havana');

const RouteAuth = (props) => {
  const { loginRequired, path, component } = props;
  if (loginRequired) {
    return (
      <AuthProvider>
        <Route path={path} component={component}/>
      </AuthProvider>
    );
  }
  return <Route path={path} component={component}/>;
};

ReactDOM.render(
  <ApolloProvider client={adminClient}>
    <RouterContext.Provider value={history}>
      <GraphqlErrorBoundary>
        <Router history={history}>
          <Switch>
            {indexRoutes.map((prop) => (
              <RouteAuth
                loginRequired={prop.loginRequired}
                path={prop.path}
                component={prop.component}
                key={prop.name}/>
            ))}
          </Switch>
        </Router>
      </GraphqlErrorBoundary>
    </RouterContext.Provider>
  </ApolloProvider>,
  document.getElementById('root'),
);
